import React from "react";
import { motion } from "framer-motion";

const SectionHeader = ({ code, title, kicker, tid }) => (
  <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-16">
    <div>
      <div className="micro-label text-cyan-400 mb-3" data-testid={`${tid}-code`}>
        {code}
      </div>
      <h2
        className="font-display font-black uppercase tracking-tighter leading-[0.9] interactive-text interactive-text--white break-words"
        style={{ fontSize: "clamp(1.75rem, 6vw, 5rem)" }}
        data-testid={`${tid}-title`}
      >
        {title}
      </h2>
    </div>
    {kicker && (
      <p className="max-w-md text-sm md:text-base text-white/60 md:text-right">
        {kicker}
      </p>
    )}
  </div>
);

export const SectionWrapper = ({ id, children, className = "" }) => (
  <section
    id={id}
    className={`relative py-20 md:py-32 px-5 md:px-10 snap-section snap-reveal ${className}`}
    data-testid={`section-${id}`}
  >
    <div className="max-w-[1400px] mx-auto w-full relative z-10">{children}</div>
  </section>
);

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export default SectionHeader;
